export function PaymentTestModeBanner() {
  // Banner removido a pedido — sandbox continua a funcionar por baixo até Go-Live ficar concluído.
  return null;
}
